import React, { ReactElement } from 'react';
import { BulletList, SkeletonText, SkeletonTextLine, Typography } from '@vp/swan';
import { useValidationContext } from 'src/hooks/ValidationContextHooks';
import { text } from 'src/utils/localizationUtil';
import { FileRequirementBullet } from './FileRequirementBullet';

export interface FileRequirement {
  correspondingValidationId: string;
  bulletPointI18nKey: string;
  errorMessageI18nKey: string;
  productOptionName?: string;
}

export type FileRequirementsProps = {
  isMobile: boolean;
};

export const FileRequirements = ({ isMobile }: FileRequirementsProps): ReactElement => {
  const { validations, validationPlaceholders } = useValidationContext();

  const validationsToShow = validations ?? validationPlaceholders;
  return (
    <>
      <Typography fontSkin="title-subsection" mb={'4'}>
        {text('file-requirements')}
      </Typography>
      {validationsToShow ? (
        <BulletList>
          {validationsToShow.map(validation => (
            <FileRequirementBullet requirement={validation} key={validation.id} isMobile={isMobile} />
          ))}
        </BulletList>
      ) : (
        <SkeletonText>
          <SkeletonTextLine />
          <SkeletonTextLine />
          <SkeletonTextLine />
          <SkeletonTextLine />
        </SkeletonText>
      )}
    </>
  );
};
